<form class="modal-body" [formGroup]="form" (ngSubmit)="submit()" novalidate>
  <p class="centermodal__title">{{ isEditingEndpoint ? ('button.edit' | translate) : ('button.add' | translate) }} endpoint</p>

  <div>
    <label [loadingAnimation]="isLoadingInputs && isEditingEndpoint" class="field__holder full" [appFormControlWrap]="form.get('name')">
      <input type="text" class="field" formControlName="name" autocomplete="none" required role="presentation" autocorrect="off" spellcheck="false" autocapitalize="off" />
      <span class="field__placeholder">{{ 'webhooks.endpointName' | translate }}</span>
    </label>

    <label [loadingAnimation]="isLoadingInputs && isEditingEndpoint" class="field__holder full" [appFormControlWrap]="form.get('url')">
      <input type="text" class="field" formControlName="url" required autocomplete="none" role="presentation" autocorrect="off" spellcheck="false" autocapitalize="off" />
      <span class="field__placeholder">URL</span>
    </label>

    <app-select
      [loadingAnimation]="isLoadingInputs && isEditingEndpoint"
      style="width: 223px"
      placeholder="{{ 'webhooks.webhookFormat' | translate }}"
      [disableSearch]="true"
      [ngModelOptions]="{ standalone: true }"
      [(ngModel)]="webhookFormat"
      (ngModelChange)="form.get('format').setValue($event)"
      [options]="[
        { key: webhookFormatEnum.Urlencoded, value: 'URL encoded', height: 46, fontSize: 16 },
        { key: webhookFormatEnum.Json, value: 'JSON', height: 46, fontSize: 16 }
      ]"
    >
    </app-select>

    <div class="centermodal__group mt-3">
      <div class="centermodal__switch mb-2">
        <app-switch
          [(ngModel)]="hasBearerToken"
          [ngModelOptions]="{ standalone: true }"
          [disabled]="isLoading || !currentUser?.subscription.has_premium_features"
          (pointerdown)="userService.checkPremiumFeatures($event, currentUser)"
        ></app-switch>
        <span class="centermodal__switch-name"
          ><span class="pro" [attr.data-pro-text]="translateService.instant('shared.pro')">{{ 'webhooks.authentication' | translate }}</span></span
        >
      </div>

      <label [loadingAnimation]="isLoadingInputs && isEditingEndpoint" class="field__holder full mb-0" [appFormControlWrap]="form.get('authorization_token')" *ngIf="hasBearerToken">
        <span class="field__fakeContent" *ngIf="this.endpoint?.id && this.endpoint?.has_authorization_token && !form.get('authorization_token')?.value">***</span>
        <input
          type="text"
          class="field"
          [class.active]="this.endpoint?.id && endpoint?.has_authorization_token"
          formControlName="authorization_token"
          autocomplete="none"
          role="presentation"
          autocorrect="off"
          spellcheck="false"
          autocapitalize="off"
        />
        <span class="field__placeholder">Bearer token</span>
      </label>
    </div>

    <div class="centermodal__group mb-0">
      <div class="centermodal__switch mb-0">
        <app-switch formControlName="requires_static_ip" (pointerdown)="userService.checkPremiumFeatures($event, currentUser)"></app-switch>
        <span class="centermodal__switch-name"
          ><span class="pro" [attr.data-pro-text]="translateService.instant('shared.pro')">{{ 'webhooks.useStaticIpForWebhook' | translate }}</span></span
        >
      </div>

      <div class="copy__holder">
        <div class="copy mt-2" (click)="copyStaticIp('35.198.37.57')" *ngIf="form.get('requires_static_ip').value">35.198.37.57</div>
        <div class="copy mt-2" (click)="copyStaticIp('34.151.202.249')" *ngIf="form.get('requires_static_ip').value">34.151.202.249</div>
      </div>
    </div>

    <div class="centermodal__group-title">{{ 'webhooks.events' | translate }}</div>

    <app-select
      [loadingAnimation]="isLoadingInputs && isEditingEndpoint"
      style="width: 223px"
      placeholder="{{ 'webhooks.eventType' | translate }}"
      [disableSearch]="true"
      [ngModelOptions]="{ standalone: true }"
      [(ngModel)]="selectedEventType"
      (ngModelChange)="changeEventType($event)"
      [options]="eventSelectOptions"
    >
    </app-select>

    <div class="form" formGroupName="events">
      <div class="form__header">
        <p class="form__header__text">{{ 'webhooks.eventsThatTriggerHook' | translate }}</p>
      </div>

      <div *ngIf="isLoadingInputs" class="form__" [loadingAnimation]="isLoadingInputs" class="form__list">
        <div [loadingAnimation]="isLoadingInputs" class="form__list"></div>
      </div>

      <div *ngFor="let group of autentiqueEvents" class="form__list__group">
        <div *ngIf="selectedEventType == group.object && !isLoading">
          <div *ngFor="let event of group.events" class="form__list">
            <app-checkbox [cursor]="'pointer'" class="checkbox" [value]="isEventSelected(event.enum_key)" (change)="onCheckboxChange($event, event.name)"></app-checkbox>
            <label [for]="data_adicao_signer">{{ event.name }}</label>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="centermodal__button-group">
    <button type="button" class="btn-L btn-filled-cancel" (click)="cancel()">{{ 'button.cancel' | translate }}</button>
    <button type="submit" class="btn-L btn-filled" [disabled]="isLoading">{{ 'button.save' | translate }}</button>
  </div>
</form>
